import React, { useContext, useMemo } from 'react';
import classNames from 'classnames';
import { get, isArray, flatten, isEmpty } from '@libs/shared';
import { PLUGIN_ARGUMENT_FIELD_TYPE, PLUGIN_ARGUMENT_VALUE_FROM } from '../../../interfaces';
import PluginMemberSelect from './components/plugin-member-select';
import { PluginComponentContext } from '../plugin-component';
import FieldVariableSelect from '../field-variable-select';

interface MemberValue {
    departs?: string[];
    roles?: string[];
    users?: string[];
}

/**
 * 插件-成员字段
 * @param props
 */
const PluginMember: React.FC = () => {
    const pluginComponentStore = useContext(PluginComponentContext);

    const value = pluginComponentStore?.fieldValue?.resolver_arg;

    const flattenValueString = flatten([
        get(value, 'departs', []),
        get(value, 'roles', []),
        get(value, 'users', [])
    ]).toString();

    const memberSelectValue = useMemo(() => {
        return {
            departments: get(value, 'departs', []),
            roles: get(value, 'roles', []),
            users: get(value, 'users', [])
        };
    }, [flattenValueString]);

    if (!pluginComponentStore) {
        return null;
    }

    const { field, fieldValue, isView, checkStatusVisible, onChange } = pluginComponentStore;

    const renderContext = () => {
        const selectType = get(fieldValue, 'resolver_type', PLUGIN_ARGUMENT_VALUE_FROM.LITERAL);
        const { isRequired, isEnabled } = field;

        if (selectType === PLUGIN_ARGUMENT_VALUE_FROM.LITERAL) {
            return (
                <PluginMemberSelect
                    disabled={!isEnabled || isView}
                    valuePanelClassName={classNames('value-panel', {
                        'is-error': checkStatusVisible && isRequired && !flattenValueString
                    })}
                    defaultValue={memberSelectValue}
                    onOk={(v) => {
                        const argValue: MemberValue = {};

                        const departs = v?.departments;
                        const roles = v?.roles;
                        const users = v?.users;

                        if (!isEmpty(departs)) {
                            argValue.departs = departs;
                        }
                        if (!isEmpty(roles)) {
                            argValue.roles = roles;
                        }
                        if (!isEmpty(users)) {
                            argValue.users = users;
                        }
                        onChange(isEmpty(argValue) ? undefined : argValue);
                    }}
                />
            );
        }
        if (selectType === PLUGIN_ARGUMENT_VALUE_FROM.PROCESS_VAR) {
            return (
                <FieldVariableSelect
                    value={isArray(value) ? value : undefined}
                    argumentType={PLUGIN_ARGUMENT_FIELD_TYPE.USER}
                />
            );
        }
    };

    return <div className="fx-plugin-member">{renderContext()}</div>;
};

export default PluginMember;
